import React from 'react'
import LowOvarianBanner from "../components/img/LowOvarianBanner.jpg";
const LowOvarianReserveBanner = () => {
  return (
    <div>
    <div id="carouselExampleCaptions" className="carousel slide" data-bs-ride="carousel">
      <div className="carousel-inner">
        <div className="carousel-item active">
          <img src={LowOvarianBanner} className="d-block w-100 carousel-image" alt="..." />
        </div>
      </div>
    </div>
  </div>
  )
}

export default LowOvarianReserveBanner
